export const PRIVY_APP_ID = process.env.REACT_APP_PRIVY_APP_ID ?? ''
export const ZERODEV_PROJECT_IDS = [process.env.REACT_APP_ZERODEV_PROJECT_ID ?? '']